<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card
      :title="
        ($route.query.id ? '修改' : '新增') +
        ($route.query.type === 'my' ? '我的车辆' : '外调车辆')
      "
    >
      <BaseForm
        ref="baseForm"
        @switchToInvite="fnSwitchToInvite"
        @vehicleClassChange="vehicleClassChange"
        @energyTypeChange="energyTypeChange"
      />
      <DriverInfoForm ref="driverInfoForm" :vehicleClass="vehicleClass"/>
      <LicenseInfoForm
        ref="licenseInfoForm"
        @drivingLicenseInfo="getDrivingLicenseInfo"
      />
      <ParametersForm ref="parametersForm" />
      <VehiclePictureForm ref="vehiclePictureForm" />
      <!-- <MakeAndBrandForm ref="makeAndBrandForm" /> -->
      <!-- <BelongForm ref="belongForm" /> -->
      <!-- <OilConsumptionForm ref="oilConsumptionForm" /> -->
      <CostInfoForm ref="costInfoForm" />
      <InsuranceInfoForm ref="insuranceInfoForm" />
      <MaintenanceInfoForm ref="maintenanceInfoForm" />
      <!-- 已注册，邀请需要显示的组件 start-->
      <BelongInfoForm ref="belongInfoForm" />
      <BoundDriverForm ref="boundDriverForm" />
      <InviteDescForm ref="inviteDescForm" />
      <!-- 已注册，邀请需要显示的组件 end-->
      <TransferForm ref="transferForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import ParametersForm from './parameters';
// import MakeAndBrandForm from './makeAndBrand';
import VehiclePictureForm from './vehiclePicture';
// import BelongForm from './belong';
import BelongInfoForm from './belongInfo';
// import OilConsumptionForm from './oilConsumption';
import DriverInfoForm from './driverInfo';
import LicenseInfoForm from './licenseInfo';
import CostInfoForm from './costInfo';
import InsuranceInfoForm from './insuranceInfo';
import BoundDriverForm from './boundDriver';
import InviteDescForm from './inviteDesc';
import TransferForm from './transfer';
import SubBtnBox from 'components/subBtnBox';
import MaintenanceInfoForm from './maintenanceInfo';
import {
  vehicleDoSave,
  getAllVehicleInfo,
  // doSaveApplyRecordForOwnCar,
} from 'api/car';
import {
  getEnumList,
  queryStaticDataOption,
  getCarTypeList,
  getDepartmentAllList,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
import {mapState} from 'vuex';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    ParametersForm,
    // MakeAndBrandForm,
    VehiclePictureForm,
    // BelongForm,
    BelongInfoForm,
    // OilConsumptionForm,
    DriverInfoForm,
    LicenseInfoForm,
    CostInfoForm,
    InsuranceInfoForm,
    BoundDriverForm,
    InviteDescForm,
    TransferForm,
    SubBtnBox,
    MaintenanceInfoForm,
  },
  data () {
    return {
      // 是否切换到邀请模式（和新建修改请求的接口不同）
      isSwitchToInvite: false,
      // 用于判断自有车档案处，其他三种种类修改为外调车的情况
      vehicleClass: '',
      pageUrl: '/manage/car/archives/edit',
      formComponents: [
        'baseForm',
        'parametersForm',
        'vehiclePictureForm',
        // 'makeAndBrandForm',
        // 'belongForm',
        'belongInfoForm',
        // 'oilConsumptionForm',
        'driverInfoForm',
        'licenseInfoForm',
        'costInfoForm',
        'insuranceInfoForm',
        'boundDriverForm',
        'inviteDescForm',
        'transferForm',
        'maintenanceInfoForm',
      ],

      subLoading: false,
      // 需要对比的参数
      compareParams: {
        ext: {},
        plateNumber: '',
        vehicleClass: '',
        orgId: '',
        licenceType: '',
        remark: '',
        vehicleStatus: '',
        vehicleLength: '',
        vehicleLoad: '',
        lightGoodsSquare: '',

        driverUserId: '',
        copilotDriverId: '',

        drivingLicense: '',
        adriverLicenseCopy: '',
        drivingLicenseOwner: '',
        drivingLicenseDate: '',
        vehicleValidityTime: '',

        brandModel: '',
        vinNo: '',
        engineNo: '',

        carRegistrationPicture: '',
        vehiclePicture: '',
        specialOperCertFileId: '',

        vehicleOwnerShip: '',
        vehiclelineRels: [],
        isUseCarOilCost: '',
        loadFullOilCost: '',
        loadEmptyOilCost: '',
        purchaseDate: '',
        price: '',
        residual: '',
        depreciatedMonth: '',

        insuranceTimeEnd: '',
        busiInsuranceTimeEnd: '',

        maintainMethod: '',
        nextMaintainTime: '',
        maintainWaringDay: '',
        accumulatedMileage: '',
        mileageDriven: '',
        gasificationCertificate: '',
      },
    };
  },
  computed: {
    detailParams () {
      return {
        vehicleCode: this.$route.query.id,
      };
    },
    editParams () {
      return {
        isSwitchToInvite: this.isSwitchToInvite,
      };
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    detailApi: getAllVehicleInfo,
    editApi: vehicleDoSave,
    // 处理对比参数
    adjustCompareParams (compareParams) {
      if (compareParams.ext) {
        compareParams['ext.vehicleOrigin'] = compareParams.ext.vehicleOrigin;
        compareParams['ext.brandModel'] = compareParams.ext.brandModel;
        compareParams['ext.axleNumber'] = compareParams.ext.axleNumber;
        compareParams['ext.driveType'] = compareParams.ext.driveType;
      }
      compareParams.purchaseDate = this.formatDate(compareParams.purchaseDate);
      compareParams.insuranceTimeEnd = this.formatDate(compareParams.insuranceTimeEnd);
      compareParams.busiInsuranceTimeEnd = this.formatDate(compareParams.busiInsuranceTimeEnd);
      compareParams.nextMaintainTime = this.formatDate(compareParams.nextMaintainTime);
      if (compareParams.vehiclelineRels) {
        compareParams.vehicleLineRelsArray = JSON.stringify(compareParams.vehiclelineRels);
      }
    },
    getDrivingLicenseInfo (info) {
      // 设置车辆参数
      this.$refs.parametersForm.setVehicleParams(info);
      this.$refs.baseForm.setVehicleParams(info);
    },
    // 根据车牌号码的注册状态，切换各个表单的显示隐藏
    fnSwitchToInvite (vehicleInfo) {
      this.isSwitchToInvite = !!vehicleInfo;
      for (let item of this.formComponents) {
        if (this.$refs[item].receivedData) {
          this.$refs[item].receivedData(vehicleInfo);
        }
      }
    },
    // 切换标题
    vehicleClassChange (vehicleClass) {
      this.$refs.inviteDescForm.pageTitleChange(vehicleClass);
      this.$refs.transferForm.vehicleClassChange(vehicleClass);
      this.vehicleClass = vehicleClass;
      if (Number(vehicleClass) === 3) {
        // 车辆种类为外调车
        for (let item of this.formComponents) {
          if (this.$refs[item].changeToOutward) {
            this.$refs[item].changeToOutward();
          }
        }
      } else {
        // 车辆种类为其他
        for (let item of this.formComponents) {
          if (this.$refs[item].resetToNormal) {
            this.$refs[item].resetToNormal(vehicleClass);
          }
        }
      }
    },
    energyTypeChange (data) {
      this.$refs.licenseInfoForm.setIsEEnergyType(data === 'E'); // 能源类型是否是天然气类型
    },
    async handleSubSucc (res) {
      if (this.isSwitchToInvite) {
        // 邀请状态提交成功，提示用户
        this.$alert('您提交的申请已发给车队处理，请耐心等待。可在邀请记录中查看审核结果。若对处理结果有异议可申请平台仲裁。', '保存成功', {
          confirmButtonText: '确定',
        });
      } else {
        if (res && res.code === 202) {
          // 帮后端处理一下展示格式
          res.msg = res.msg.replace(/成功/, '成功！').replace(/\,/g, '，');
          this.$alert(res.msg, '温馨提示', {
            confirmButtonText: '我知道了',
          });
        } else {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
        }
      }
      this.close();
    },
  },
  async mounted () {
    const staticDataOption = await queryStaticDataOption({
      codeType: 'WARING_DAY',
    });
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_CLASS,LICENCE_TYPE,VEHICLE_BRAND,OWNER_SHIP,MAINTAIN_METHOD,ENERGY_TYPE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    const getStaticValue = (label) => {
      const item = Array.isArray(staticDataOption) ? staticDataOption.find((option) => option.label === label) : null;
      return item ? item.value : '';
    };
    // 获取以及设置各种组件表单所需的枚举值
    const vehicleStatusEnumsList = await getCarTypeList();
    if (this.$refs.baseForm) {
      const vehicleEarlyWarningDay = getStaticValue('vehicleEarlyWarningDay');
      const otherEarlyWarningDay = getStaticValue('otherEarlyWarningDay');
      const operateEarlyWarningDay = getStaticValue('operateEarlyWarningDay');
      const gpsWaringDay = getStaticValue('gpsWaringDay');
      const orgIdOptions = await getDepartmentAllList({
        pid: this.userInfo.staffTFInfo.orgIds,
        isArchive: true,
      });

      this.$refs.baseForm.setList({
        vehicleClassOptions: safeEnum(0),
        vehicleEarlyWarningDay,
        otherEarlyWarningDay,
        operateEarlyWarningDay,
        gpsWaringDay,
        orgIdOptions,
        licenceTypeOptions: safeEnum(1),
        vehicleStatusOptions: Array.isArray(vehicleStatusEnumsList) ? vehicleStatusEnumsList : [],
        energyTypeOptions: safeEnum(5),
      });
    }
    this.$refs.parametersForm && this.$refs.parametersForm.setList(safeEnum(2));
    if (this.$refs.costInfoForm) {
      this.$refs.costInfoForm.setList([{ label: '请选择', value: '-1' }, ...safeEnum(3)]); // 车辆性质
    }
    if (this.$refs.insuranceInfoForm) {
      const earlyWarningDay = getStaticValue('earlyWarningDay');
      const busiEarlyWarningDay = getStaticValue('busiEarlyWarningDay');
      this.$refs.insuranceInfoForm.setList([earlyWarningDay, busiEarlyWarningDay]); // 车辆性质
    }
    if (this.$refs.maintenanceInfoForm) {
      this.$refs.maintenanceInfoForm.setList({
        maintainMethodOptions: safeEnum(4),
      });
    }
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
